import { type PropsWithChildren } from 'react';

import HandleRedirect from './HandleRedirect';
import shouldRedirect from './shouldRedirect';

const GladeRedirectProvider: React.FC<PropsWithChildren> = ({ children }) => {
  if (!shouldRedirect()) {
    return <>{children}</>;
  }
  return <HandleRedirect />;
};

export default GladeRedirectProvider;
